<template>
  <div id="app">
    <el-container>
      <el-header><index-top></index-top></el-header>
      <el-main><router-view :key="key"/></el-main>
      <el-footer><index-bottom></index-bottom></el-footer>
    </el-container>
  </div>
</template>

<script>
import indexTop from '@/components/layout/indexTop.vue'
import indexBottom from '@/components/layout/indexBottom.vue'
export default {
  name: 'Home',
  components: {
    indexTop,
    indexBottom
  },
  computed:{
    key(){
      return this.$route.query?this.$route.query+new Date():this.$route+new Date()
    }
  }
}
</script>

<style lang="less">
#app{
  .el-header,.el-footer,.el-main{
    padding: 0;
  }
  .el-main{
    background-color: #ececec;
  }
}
</style>
